import { ReactElement, useState } from 'react';
import { Modal, TextLink, Tooltip } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import { NotAdvancedModal } from './modal';

import styles from './index.module.scss';

type Props = {
  children: ReactElement;
};

export const NotAdvanced = ({ children }: Props) => {
  const fm = useFm();
  const [visible, setVisible] = useState(false);

  const content = (
    <div onClick={(e) => e.stopPropagation()}>
      <div className={styles.text}>{fm('curProjNotAdvAllPtsLock')}</div>
      <TextLink
        className="mt-[4px]"
        variant="primary"
        size="small"
        onClick={() => setVisible(true)}
      >
        {fm('readMore')}
      </TextLink>
    </div>
  );

  return (
    <>
      <Tooltip placement="bottom" title={content} hasDashedLine>
        {children}
      </Tooltip>
      <NotAdvancedModal
        show={visible}
        onClose={() => {
          setVisible(false);
        }}
      />
    </>
  );
};
